module.exports = __webpack_public_path__ + "static/media/mobilebg3.ce57915c.jpg";